import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NotFounds from '../views/Page/NotFoundsView.vue'
import { useToast } from 'vue-toastification'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// Utility for cookie access
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

const routes = [
  { path: '/', name: 'home', component: HomeView, meta: { title: 'الرئيسية' } },
  { path: '/facebook', name: 'facebook', component: () => import('../views/Page/FacebookView.vue'), meta: { title: 'فيسبوك' } },
  { path: '/x', name: 'x', component: () => import('../views/Page/TwitterView.vue'), meta: { title: 'تويتر' } },
  { path: '/video/:content_id', name: 'video', component: () => import('../views/Page/VideoPlayView.vue'), props: true, meta: { requiresAuth: true, title: 'فيديو' } },
  { path: '/signin', name: 'signin', component: () => import('../views/User/LoginView.vue'), meta: { title: 'تسجيل الدخول' } },
  { path: '/unsubscribe', name: 'unsubscribe', component: () => import('../views/User/UnsubscribesView.vue'), meta: { title: 'الغاء الاشتراك' } },
  { path: '/profile', name: 'profile', component: () => import('../views/User/ProfileView.vue'), meta: { title: 'الملف الشخصي' } },
  { path: '/thank-you', name: 'thankyou', component: () => import('../views/User/ThankYouView.vue'), meta: { title: 'شكرا لك' } },
  { path: '/contacts', name: 'contacts', component: () => import('../views/Page/ContactsView.vue'), meta: { title: 'تواصل معنا' } },
  { path: '/:pathMatch(.*)*', name: 'NotFounds', component: NotFounds, meta: { title: 'غير موجود' } },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  },
})

// Progress bar for route changes
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});
router.afterEach(() => {
  NProgress.done();
});

// Set document title from route meta
router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' | تريند';
  }
});

// Auth guard
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const msisdn = getCookie('msisdn');
    const minutes = parseInt(getCookie('remaining_minutes')) || 0;
    if (msisdn && minutes > 0) {
      next();
    } else {
      window.location.href = 'http://digitalcg.net/655/G0wo';
    }
  } else {
    next();
  }
});

export default router
